const ADD_TO_CART = "ADD_TO_CART";
const REMOVE_FROM_CART = "REMOVE_FROM_CART";
const UPDATE_CART_QTY = "UPDATE_CART_QTY";
const CLEAR_CART = "CLEAR_CART";

const initialState = {
  cart: JSON.parse(localStorage.getItem("cart")) || [],
};

// 🔥 UNIQUE KEY GENERATOR (VERY IMPORTANT)
const getItemKey = (item) => {
  return `${item.product}_${item.size}_${item.color}`;
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {

    // ✅ ADD TO CART (FIXED COMPLETELY)
case ADD_TO_CART: {
      const item = action.payload;
      const itemKey = getItemKey(item);
console.log("PAYLOAD", action.payload);
      let existItem = state.cart.find(
        (i) => getItemKey(i) === itemKey
      );

      let updatedCart;

      if (existItem) {
        updatedCart = state.cart.map((i) =>
          getItemKey(i) === itemKey
            ? { ...i, quantity: i.quantity + item.quantity }
            : i
        );
      } else {
        updatedCart = [...state.cart, item];
      }

      localStorage.setItem("cart", JSON.stringify(updatedCart));

      return {
        ...state,
        cart: updatedCart,
      };
    }

    // ✅ REMOVE
    case REMOVE_FROM_CART: {
      const key = `${action.payload.id}_${action.payload.size}_${action.payload.color}`;

      const updatedCart = state.cart.filter(
        (i) => getItemKey(i) !== key
      );

      localStorage.setItem("cart", JSON.stringify(updatedCart));

      return {
        ...state,
        cart: updatedCart,
      };
    }

    // ✅ UPDATE QTY
    case UPDATE_CART_QTY: {
      const key = `${action.payload.id}_${action.payload.size}_${action.payload.color}`;

      const updatedCart = state.cart.map((i) =>
        getItemKey(i) === key
          ? {
              ...i,
              quantity: action.payload.qty < 1 ? 1 : action.payload.qty,
            }
          : i
      );

      localStorage.setItem("cart", JSON.stringify(updatedCart));

      return {
        ...state,
        cart: updatedCart,
      };
    }

    // ✅ CLEAR
    case CLEAR_CART:
      localStorage.removeItem("cart");
      return { cart: [] };

    default:
      return state;
  }
}